<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import RealignmentTable from "@/components/tables/realignment-table.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import ViewItems from "@/components/modals/modification-items.vue"
export default {
  name: "Realignment",
  components: {
    Layout,
    PageHeader,
    RealignmentTable,
    PrintOptions,
    ViewItems
  },
  data() {
    return {
      title: "Modification of Budget Requests",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Modification of Budget Requests",
          active: true,
        },
      ],
      cycle: Number(this.$store.getters["data/getCycle"]),
      selectedCampus: this.$store.state.data.selectedCampus.id,
      posted: [],
      approved: [],
      manageBudget: false
    };
  },
  methods: {
    changeCycle(cycle) {
      this.cycle = cycle;
      this.$store.commit("data/changeCycle", cycle);
      this.fetchApproved();
      this.fetchPosted();
    },
    changeCampus(data) {
      this.selectedCampus = data.id;
      this.fetchApproved();
      this.fetchPosted();
    },
    fetchPosted() {
      this.$store.commit("realignmentrequest/SET_POSTED_REALIGNMENT_LOADING", true);
      this.$store
        .dispatch("realignmentrequest/GetPostedRealignmentCampus", {
          campusId: this.selectedCampus,
          cycle: this.cycle,
        })
        .then((response) => {
          if (response.data.error) {
            this.$store.commit("realignmentrequest/SET_POSTED_REALIGNMENT_LOADING", false);
            return this.showToast(response.data.errorMessage, "error");
          }
          this.posted = response.data
            .sort((a, b) => {
              return b.id - a.id;
            })
            .map((item) => ({
              ...item,
              showDetails: false,
              items: [],
              accounts: [],
              isLoading: false,
            }));
          this.$store.commit("realignmentrequest/SET_POSTED_REALIGNMENT_LOADING", false);
        })
        .catch((error) => {
          this.$store.commit("realignmentrequest/SET_POSTED_REALIGNMENT_LOADING", false);
          return this.showToast(error.response.data.errorMessage, "error");
        });
    },
    fetchApproved() {
      this.$store.commit("realignmentrequest/SET_APPROVED_REALIGNMENT_LOADING", true);
      this.$store
        .dispatch("realignmentrequest/GetApprovedRealignmentCampus", {
          campusId: this.selectedCampus,
          cycle: this.cycle,
        })
        .then((response) => {
          if (response.data.error) {
            this.$store.commit(
              "realignmentrequest/SET_APPROVED_REALIGNMENT_LOADING",
              false
            );
            return this.showToast(response.data.errorMessage, "error");
          }

          this.approved = response.data
            .sort((a, b) => {
              return b.id - a.id;
            })
            .map((item) => ({
              ...item,
              showDetails: false,
              items: [],
              accounts: [],
              isLoading: false,
            }));
          this.$store.commit(
            "realignmentrequest/SET_APPROVED_REALIGNMENT_LOADING",
            false
          );
        })
        .catch((error) => {
          this.$store.commit(
            "realignmentrequest/SET_APPROVED_REALIGNMENT_LOADING",
            false
          );
          return this.showToast(error.response.data.errorMessage, "error");
        });
    },
    returnRequest(data) {
      this.$swal({
        title: "Enter Your Remarks",
        input: "textarea",
        inputPlaceholder: "Type your remarks here...",
        inputAttributes: {
          "aria-label": "Type your remarks here",
        },
        showCancelButton: true,
        confirmButtonText: "Return",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          this.pageLoader(true);
          this.$store
            .dispatch("realignmentrequest/ReturnRealignment", {
              id: data.id,
              remarks: result.value,
            })
            .then((response) => {
              if (response.data.error) {
                return this.showToast(response.data.errorMessage, "error");
              }
              this.fetchPosted();
              this.fetchApproved();
              this.pageLoader(false);
              this.showToast(
                "Budget modification has been returned to delivery unit",
                "success"
              );
            })
            .catch((error) => {
              this.pageLoader(false);
              return this.showToast(
                "Something went wrong. Cannot return realignment request",
                "error"
              );
            });
        }
      });
    },
    approveRequest(data) {
      this.pageLoader(true);
      this.$store
        .dispatch("realignmentrequest/ApproveRealignment", data.id)
        .then((response) => {
          if (response.data.error) {
            return this.showToast(response.data.errorMessage, "error");
          }
          this.fetchPosted();
          this.fetchApproved();
          this.showToast("Budget modification has been approved", "success");
          this.pageLoader(false);
        })
        .catch((error) => {
          this.pageLoader(false);
          return this.showToast(
            "Something went wrong. Cannot approve realignment request",
            "error"
          );
        });
    },
    printRealignment(id) {
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/Realignment",
        routeVariables: [id],
      });
      this.$bvModal.show("print-options-modal");
    },
    viewModifItems(items){
      this.$bvModal.show("modif-items-modal");
      this.$refs.viewItems.setItems(items);
    },
    generateReport(type){
      this.$refs.printOpt.putOptions({
        apiUrl: "/api/Report/Finance/Modification",
        routeVariables: [this.$store.state.data.selectedCampus.id, this.$store.state.data.cycle, type],
      });
      this.$bvModal.show("print-options-modal");
    }
  },
  created() {
    if (this.$store.state.decrypt.isAdmin()) {
      this.manageBudget = true;
    } else {
      let accessList = this.$store.state.decrypt.userAccessList();
      let access = accessList.find(
        (x) =>
          x.Access.toLowerCase() === "manage budget modification" &&
          x.Type.toLowerCase() === "finance"
      );
      if (access) {
        this.manageBudget = true;
      } else {
        this.manageBudget = false;
      }
    }
    this.fetchPosted();
    this.fetchApproved();
  },
};
</script>

<template>
  <Layout @changeCycle="changeCycle"
          @changeCampus="changeCampus">
    <PageHeader :title="title"
                :items="items" />
    <b-tabs content-class="mt-4 px-2"
            nav-class="nav-tabs-custom">
      <b-tab title="For Approval">
        <RealignmentTable 
          :realignment="posted"
          status="requested"
          @returnRequest="returnRequest"
          @print="printRealignment"
          @approveRequest="approveRequest" 
          @view-modif-items="viewModifItems" 
          @generate-report="generateReport(false)"
          :manageBudget="manageBudget"
        />
      </b-tab>
      <b-tab title="Approved">
        <RealignmentTable 
          :realignment="approved"
          status="approved"
          @returnRequest="returnRequest"
          @print="printRealignment"
          @approveRequest="approveRequest" 
          @view-modif-items="viewModifItems" 
          @generate-report="generateReport(true)"
          :manageBudget="manageBudget"
        />
      </b-tab>
    </b-tabs>
    <print-options ref="printOpt"></print-options>
    <view-items ref="viewItems"></view-items>
  </Layout>
</template>
